import React from "react";
import { Button, TopToolbar } from "react-admin";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const BackButtonToolbar = ({ additionalButton = null }) => {
  const navigate = useNavigate();
  return (
    <TopToolbar sx={{ paddingTop: "2rem" }}>
      {additionalButton}
      {/* Icon as a child, not startIcon: on mobile react-admin's Button renders only its children. */}
      <Button
        label="Назад"
        variant="contained"
        size="medium"
        color="error"
        onClick={() => navigate(-1)}
      >
        <ArrowBackIcon />
      </Button>
    </TopToolbar>
  );
};

export default BackButtonToolbar;
